webpackJsonp([7555878655471],{

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(78);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _outboundLink = __webpack_require__(13);
	
	var _outboundLink2 = _interopRequireDefault(_outboundLink);
	
	var _stylesModule = __webpack_require__(98);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(_ref) {
	  var title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.contact },
	    _react2.default.createElement(
	      'h1',
	      null,
	      title || 'I like messages.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _stylesModule2.default.email },
	      'Say hello and send an email:',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:saburq@gmail.com?subject=Hello%20Shoaib!', className: _stylesModule2.default.link },
	        'saburq@gmail.com'
	      )
	    ),
	    _react2.default.createElement('div', { className: _stylesModule2.default.lineBreak }),
	    _react2.default.createElement(
	      'ul',
	      { className: _stylesModule2.default.social },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://github.com/sabman/' },
	          _react2.default.createElement(_icon2.default, { name: 'github' }),
	          ' code'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://scholar.google.com/citations?hl=en&view_op=list_works&user=Pg-Ik9AAAAAJ' },
	          _react2.default.createElement(_icon2.default, { name: 'googlescholar' }),
	          ' papers'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://leanpub.com/u/sabman' },
	          _react2.default.createElement(_icon2.default, { name: 'leanpub' }),
	          ' books'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://medium.com/@sabman/' },
	          _react2.default.createElement(_icon2.default, { name: 'medium' }),
	          ' writings'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://www.goodreads.com/user/show/15529944-shoaib-burq' },
	          _react2.default.createElement(_icon2.default, { name: 'goodreads' }),
	          ' reading'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://www.linkedin.com/in/shoaibburq/' },
	          _react2.default.createElement(_icon2.default, { name: 'linkedin' }),
	          ' linkedin'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://twitter.com/sabman/' },
	          _react2.default.createElement(_icon2.default, { name: 'twitter' }),
	          ' tweets'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://www.instagram.com/sabman' },
	          _react2.default.createElement(_icon2.default, { name: 'instagram' }),
	          ' instagram'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _outboundLink2.default,
	          { to: 'https://soundcloud.com/sabman' },
	          _react2.default.createElement(_icon2.default, { name: 'soundcloud' }),
	          ' music'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact":"src-components-contact----styles-module---contact---13_aX","lineBreak":"src-components-contact----styles-module---lineBreak---1yPvS","email":"src-components-contact----styles-module---email---3rLgN","link":"src-components-contact----styles-module---link---3_9I0","social":"src-components-contact----styles-module---social---1BgLN"};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__(100);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(_ref) {
	  var className = _ref.className,
	      name = _ref.name;
	
	  var src = __webpack_require__(135)("./" + name + '.svg');
	
	  return _react2.default.createElement('img', { src: src, className: (0, _classnames2.default)(_stylesModule2.default.icon, className), alt: name + ' icon' });
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"src-components-icon----styles-module---icon---2zdnD"};

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CjxnIGlkPSJpY29tb29uLWlnbm9yZSI+CjwvZz4KPHBhdGggZD0iTTI1Ni4wMDQgNi4zMjFjLTE0MS4zNjkgMC0yNTYuMDA0IDExNC42MDktMjU2LjAwNCAyNTUuOTk5IDAgMTEzLjEwNyA3My4zNTIgMjA5LjA2NiAxNzUuMDY4IDI0Mi45MTggMTIuNzkzIDIuMzY5IDE3LjQ5Ni01LjU1NSAxNy40OTYtMTIuMzE2IDAtNi4xMDItMC4yNC0yNi4yNzEtMC4zNDgtNDcuNjYyLTcxLjIyNCAxNS40ODgtODYuMjUyLTMwLjIwNS04Ni4yNTItMzAuMjA1LTExLjY0MS0yOS41ODgtMjguNDI0LTM3LjQ1OC0yOC40MjQtMzcuNDU4LTIzLjIyNi0xNS44ODkgMS43NTUtMTUuNTYyIDEuNzU1LTE1LjU2MiAyNS43IDEuODA1IDM5LjIzOCAyNi4zODMgMzkuMjM4IDI2LjM4MyAyMi44MzYgMzkuMTM1IDU5Ljg4OCAyNy44MiA3NC41MDIgMjEuMjc5IDIuMjk0LTE2LjU0MyA4LjkyNi0yNy44NCAxNi4yNTMtMzQuMjMyLTU2Ljg2NS02LjQ3MS0xMTYuNjM4LTI4LjQyNS0xMTYuNjM4LTEyNi41MTYgMC0yNy45NDkgMTAuMDAyLTUwLjc4NyAyNi4zOC02OC43MTQtMi42NTgtNi40NS0xMS40MjctMzIuNDg2IDIuNDc2LTY3Ljc1IDAgMCAyMS41MDMtNi44NzYgNzAuNDIgMjYuMjQ1IDIwLjQxOC01LjY3NCA0Mi4zMTgtOC41MTggNjQuMDc3LTguNjE3IDIxLjc1MSAwLjA5OSA0My42NjggMi45NDMgNjQuMTI4IDguNjE3IDQ4Ljg2Ny0zMy4xMjIgNzAuMzI4LTI2LjI0NSA3MC4zMjgtMjYuMjQ1IDEzLjkzNiAzNS4yNjQgNS4xNzUgNjEuMyAyLjUxOCA2Ny43NSAxNi40MSAxNy45MjggMjYuMzQ3IDQwLjc2NiAyNi4zNDcgNjguNzE0IDAgOTguMzI3LTU5Ljg4OSAxMTkuOTc1LTExNi44OTUgMTI2LjMxMiA5LjE4MiA3Ljk0NSAxNy4zNjIgMjMuNTIzIDE3LjM2MiA0Ny40MDYgMCAzNC4yNTQtMC4yOTggNjEuODIyLTAuMjk4IDcwLjI1NCAwIDYuODE0IDQuNjExIDE0Ljc5NyAxNy41ODYgMTIuMjgzIDEwMS42NjEtMzMuODg4IDE3NC45MjEtMTI5LjgxMyAxNzQuOTIxLTI0Mi44ODQgMC0xNDEuMzktMTE0LjYxNy0yNTUuOTk5LTI1NS45OTYtMjU1Ljk5OXoiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxLjQxNCI+PHBhdGggZD0iTTEzLjAyMiAxMC42M1YuMzI2aC0xLjM3VjIuMjZoLS4wNDNjLS4xNC0uMzAzLS4zMi0uNTkzLS41Ni0uODctLjI0LS4yNzQtLjUxLS41MTctLjgyLS43MjctLjMxLS4yMS0uNjQtLjM3My0xLjAxLS40OUM4Ljg1LjA2IDguNDYgMCA4LjA0IDBjLS44MDUgMC0xLjUzLjE1LTIuMTYuNDQ2LS42My4yOTctMS4xNi43MDMtMS41ODcgMS4yMTctLjQyNy41MTUtLjc1MyAxLjExNi0uOTc4IDEuODA0LS4yMjQuNjktLjMzNyAxLjQxNy0uMzM3IDIuMTg1IDAgLjc5Ny4wOTQgMS41NDcuMjgzIDIuMjUuMTkuNzAzLjQ5IDEuMzE1LjkxIDEuODM3LjQyLjUyLjk0LjkzIDEuNTggMS4yMi42NC4yOSAxLjQxLjQ0IDIuMzEuNDQuODMgMCAxLjU1LS4yMSAyLjE3LS42My42Mi0uNDIgMS4wOS0uOTggMS40MS0xLjY4aC4wNHYxLjUyYzAgMS4zNi0uMjggMi40LS44NCAzLjEzLS41Ni43Mi0xLjQ4IDEuMDktMi43NiAxLjA5LS4zOCAwLS43NS0uMDQtMS4xMS0uMTItLjM2LS4wOC0uNjktLjIxLS45OS0uMzgtLjI5LS4xOC0uNTUtLjQtLjc2LS42OS0uMjEtLjI5LS4zNS0uNjQtLjQyLTEuMDZIMy40Yy4wNDUuNTkuMjEgMS4xLjQ5IDEuNTMuMjgzLjQzLjY0Ljc4IDEuMDY2IDEuMDYuNDI3LjI3LjkxLjQ3IDEuNDQ1LjYuNTQuMTMgMS4wOS4yIDEuNjYuMi45MiAwIDEuNjktLjEzIDIuMzItLjM3LjYzLS4yNSAxLjE0LS42IDEuNTMtMS4wNy40LS40Ny42OC0xLjAzLjg2LTEuNy4xOC0uNjcuMjgtMS40Mi4yOC0yLjI0em0tNC45OC0uMzdjLS42MzYgMC0xLjE4Ny0uMTI2LTEuNjUtLjM4LS40NjQtLjI1My0uODUtLjU4Ny0xLjE1My0xLS4zMS0uNDEzLS41My0uODg3LS42OC0xLjQyMy0uMTUtLjUzNy0uMjItMS4wODctLjIyLTEuNjUzIDAtLjU4LjA3LTEuMTQ4LjItMS43MDYuMTQtLjU1OC4zNi0xLjA1NS42Ni0xLjQ5LjMtLjQzNC42OS0uNzg2IDEuMTUtMS4wNTQuNDYtLjI2OCAxLjAyLS40MDIgMS42Ny0uNDAyczEuMi4xMzggMS42Ni40MTNjLjQ1LjI3Ni44My42MzggMS4xMiAxLjA4Ny4yOS40NS41Ljk1LjYzIDEuNXMuMTkgMS4xMDIuMTkgMS42NTJjMCAuNTY2LS4wOCAxLjExNi0uMjMgMS42NTMtLjE1LjUzNi0uMzggMS4wMS0uNjkgMS40MjMtLjMxLjQxMy0uNjguNzQ3LTEuMTMgMS0uNDUuMjU0LS45Ny4zOC0xLjU3LjM4eiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+"

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBTdmcgVmVjdG9yIEljb25zIDogaHR0cDovL3d3dy5vbmxpbmV3ZWJmb250cy5jb20vaWNvbiAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwMCAxMDAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMDAwIDEwMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8bWV0YWRhdGE+IFN2ZyBWZWN0b3IgSWNvbnMgOiBodHRwOi8vd3d3Lm9ubGluZXdlYmZvbnRzLmNvbS9pY29uIDwvbWV0YWRhdGE+CjxnPjxnIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDAgMTUzNikiPjxwYXRoIGQ9Ik05MTUuOCwxMzEwTDk5MCw3MDEuM2MtNDEuOCwwLTgyLjgsOS4xLTEyMywyNy4zYy02My44LDI5LTEyNi41LDQzLjUtMTg4LjEsNDMuNWMtNzIuMSwwLTEzMS44LTIzLjYtMTc5LTcwLjhjLTQ3LjIsNDcuMi0xMDYuOSw3MC44LTE3OSw3MC44Yy02MS42LDAtMTI0LjMtMTQuNS0xODguMS00My41Yy00MC44LTE4LjItODEtMjcuMy0xMjAuNi0yNy4zSDEwTDg0LjIsMTMxMGM3MS41LDQwLjUsMTQ4LjMsNjAuOCwyMzAuNiw2MC44Yzc0LjMsMCwxMzYuMS0xNi45LDE4NS4yLTUwLjdjNDkuMSwzMy44LDExMC45LDUwLjcsMTg1LjIsNTAuN0M3NjcuNSwxMzcwLjcsODQ0LjQsMTM1MC41LDkxNS44LDEzMTB6IE02NzksODM3LjdjNDEuMiwwLDc4LjItNC41LDExMS0xMy42czc0LjMtMjQsMTI0LjQtNDQuN2wtNTkuMyw0ODguNmMtNTQuNiwyNC45LTExMy4yLDM3LjMtMTc2LjEsMzcuM2MtNzEuNSwwLTEzMS4xLTIyLjUtMTc5LTY3LjVjLTQ3LjksNDUtMTA3LjUsNjcuNS0xNzksNjcuNWMtNjIuOCwwLTEyMS41LTEyLjQtMTc2LjEtMzcuM0w4NS42LDc3OS4zYzMzLjUsMTMuNyw1OS45LDI0LjEsNzkuMiwzMS4xczQzLDEzLjMsNzEuMSwxOC45czU2LjUsOC40LDg1LjIsOC40YzY0LjQsMCwxMjQuMS0xNy4yLDE3OS01MS43QzU1NC45LDgyMC40LDYxNC41LDgzNy43LDY3OSw4MzcuN3ogTTY5OC4xLDg1My45bC0yNi4zLDQzNGMtNjcuMy0xLjMtMTI0LjYtMjYtMTcxLjgtNzQuMmMtNDguNSw0OS40LTEwOC4xLDc0LjItMTc5LDc0LjJjLTU2LjEsMC0xMDkuNy0xMC41LTE2MC44LTMxLjZsLTU0LjYtNDUwLjNjMzkuNiwxNi4zLDc2LDI4LjQsMTA5LjMsMzYuNHM2OC43LDEyLDEwNiwxMmM2Ni43LDAsMTI2LjMtMTYuMywxNzktNDguOGM1NC45LDM0LjEsMTE0LjUsNTAuNCwxNzksNDguOEw2OTguMSw4NTMuOXoiLz48L2c+PC9nPgo8L3N2Zz4="

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./github.svg": 126,
		"./goodreads.svg": 127,
		"./googlescholar.svg": 128,
		"./instagram.svg": 129,
		"./leanpub.svg": 130,
		"./linkedin.svg": 131,
		"./medium.svg": 132,
		"./soundcloud.svg": 133,
		"./twitter.svg": 134
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 135;


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CjxnIGlkPSJpY29tb29uLWlnbm9yZSI+CjwvZz4KPHBhdGggZD0iTTE5MiAxOTJoODguNTUzdjQ1LjM5MWgxLjI2NmMxMi4zMi0yMi4wOTcgNDIuNDc5LTQ1LjM5MSA4Ny40MjEtNDUuMzkxIDkzLjQ3MyAwIDExMC43NiA1OC4xODggMTEwLjc2IDEzMy44Njd2MTU0LjEzM2gtOTIuMzA1di0xMzYuNjM5YzAtMzIuNTkyLTAuNjY3LTc0LjUxMy00OC4wMTQtNzQuNTEzLTQ4LjA3NCAwLTU1LjQxIDM1LjQ5My01NS40MSA3Mi4xNDZ2MTM5LjAwNmgtOTIuMjcxdi0yODh6Ij48L3BhdGg+CjxwYXRoIGQ9Ik0zMiAxOTJoOTZ2Mjg4aC05NnYtMjg4eiI+PC9wYXRoPgo8cGF0aCBkPSJNMTI4IDExMmMwIDI2LjUxLTIxLjQ5IDQ4LTQ4IDQ4cy00OC0yMS40OS00OC00OGMwLTI2LjUxIDIxLjQ5LTQ4IDQ4LTQ4czQ4IDIxLjQ5IDQ4IDQ4eiI+PC9wYXRoPgo8L3N2Zz4K"

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmlld0JveD0iMCAwIDE2MCAxMjYuNjY2NjciCiAgIGhlaWdodD0iMTI2LjY2NjY3IgogICB3aWR0aD0iMTYwIgogICB4bWw6c3BhY2U9InByZXNlcnZlIgogICB2ZXJzaW9uPSIxLjEiCiAgIGlkPSJzdmcyIj48bWV0YWRhdGEKICAgICBpZD0ibWV0YWRhdGE4Ij48cmRmOlJERj48Y2M6V29yawogICAgICAgICByZGY6YWJvdXQ9IiI+PGRjOmZvcm1hdD5pbWFnZS9zdmcreG1sPC9kYzpmb3JtYXQ+PGRjOnR5cGUKICAgICAgICAgICByZGY6cmVzb3VyY2U9Imh0dHA6Ly9wdXJsLm9yZy9kYy9kY21pdHlwZS9TdGlsbEltYWdlIiAvPjwvY2M6V29yaz48L3JkZjpSREY+PC9tZXRhZGF0YT48ZGVmcwogICAgIGlkPSJkZWZzNiIgLz48ZwogICAgIHRyYW5zZm9ybT0ibWF0cml4KDEuMzMzMzMzMywwLDAsLTEuMzMzMzMzMywwLDEyNi42NjY2NykiCiAgICAgaWQ9ImcxMCI+PGcKICAgICAgIHRyYW5zZm9ybT0ic2NhbGUoMC4xKSIKICAgICAgIGlkPSJnMTIiPjxwYXRoCiAgICAgICAgIGlkPSJwYXRoMTQiCiAgICAgICAgIHN0eWxlPSJmaWxsOiMyMzFmMjA7ZmlsbC1vcGFjaXR5OjE7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOm5vbmUiCiAgICAgICAgIGQ9Im0gMTIwMCw4MTAgLTQ3LjQ2LDAgQyAxMTM0LjkyLDgxMCAxMTEwLDc4NC41ODIgMTExMCw3NjguMzA5IGwgMCwtNTg5LjgwOSBjIDAsLTE2LjI5MyAyNC45MiwtMzguNSA0Mi41NCwtMzguNSBsIDQ3LjQ2LDAgMCwtMTQwIC00MzAsMCAwLDE0MCA5MCwwIDAsNjIwIC00LjQxLDAgTCA2NDUuNDIyLDAgNDgyLjcwNywwIDI3NS4yNSw3NjAgMjcwLDc2MCAyNzAsMTQwIDM2MCwxNDAgMzYwLDAgMCwwIDAsMTQwIDQ2LjA5NzcsMTQwIEMgNjUuMDgyLDE0MCA5MCwxNjIuMjA3IDkwLDE3OC41IGwgMCw1ODkuODA5IEMgOTAsNzg0LjU4MiA2NS4wODIsODEwIDQ2LjA5NzcsODEwIEwgMCw4MTAgbCAwLDE0MCA0NTAuMTY0LDAgMTQ3Ljc5NywtNTUwIDQuMDY2LDAgMTQ5LjE2NCw1NTAgNDQ4LjgwOSwwIDAsLTE0MCIgLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTI1NiwwQzExNC42MDksMCwwLDExNC42MDksMCwyNTZjMCwxNDEuMzkxLDExNC42MDksMjU2LDI1NiwyNTZjMTQxLjM5MSwwLDI1Ni0xMTQuNjA5LDI1Ni0yNTYKCQlDNTEyLDExNC42MDksMzk3LjM5MSwwLDI1NiwweiBNMjU2LDQ3MmMtMTE5LjI5NywwLTIxNi05Ni43MDMtMjE2LTIxNlMxMzYuNzAzLDQwLDI1Niw0MHMyMTYsOTYuNzAzLDIxNiwyMTZTMzc1LjI5Nyw0NzIsMjU2LDQ3MnoKCQkiLz4KCTxnPgoJCTxnPgoJCQk8cGF0aCBkPSJNMTI4LjU5MSwyODEuNjA5Yy0yLjg3NSwxMy41LDUuMzQ0LDMyLDEyLjc4MSwzOC4zOTF2LTY0QzEzMy45MzUsMjYyLjM5MSwxMzAuNzc4LDI3MS41LDEyOC41OTEsMjgxLjYwOXoKCQkJCSBNMzQ3LjM0MSwyNTAuMTg4Yy00LjQ2OSwwLTguNjcyLDAuODc1LTEyLjYwOCwyLjI2NmMtMS45Ny0zMy42NzItMzEtNjAuNDUzLTY2LjgxMi02MC40NTMKCQkJCWMtMjIuODkxLDAtNTAuNjA5LDguOTM4LTYyLjcwMywyNS41OTRWMzIwaDE0Mi4xMjVjMjAuMjUsMCwzNi42NTYtMTUuNjI1LDM2LjY1Ni0zNC44OTEKCQkJCUMzODMuOTk3LDI2NS44MTIsMzY3LjU5MSwyNTAuMTg4LDM0Ny4zNDEsMjUwLjE4OHogTTE3OS42ODUsMzIwaDEyLjc2NnYtODkuNTk0aC0xMi43NjZWMzIweiBNMTU0LjEzOCwzMjBoMTIuNzY2di03Ni44MTIKCQkJCWgtMTIuNzY2VjMyMHoiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CjxnIGlkPSJpY29tb29uLWlnbm9yZSI+CjwvZz4KPHBhdGggZD0iTTUxMiAxMTMuMmMtMTguOCA4LjQtMzkuMSAxNC02MC4zIDE2LjUgMjEuNy0xMyAzOC4zLTMzLjYgNDYuMi01OC4xLTIwLjMgMTItNDIuOCAyMC44LTY2LjcgMjUuNS0xOS4yLTIwLjQtNDYuNS0zMy4xLTc2LjctMzMuMS01OCAwLTEwNSA0Ny0xMDUgMTA1IDAgOC4yIDAuOSAxNi4yIDIuNyAyMy45LTg3LjMtNC40LTE2NC43LTQ2LjItMjE2LjUtMTA5LjgtOSAxNS41LTE0LjIgMzMuNi0xNC4yIDUyLjggMCAzNi40IDE4LjUgNjguNiA0Ni43IDg3LjQtMTcuMi0wLjUtMzMuNC01LjMtNDcuNi0xMy4xIDAgMC40IDAgMC45IDAgMS4zIDAgNTAuOSAzNi4yIDkzLjQgODQuMyAxMDMtOC44IDIuNC0xOC4xIDMuNy0yNy43IDMuNy02LjggMC0xMy4zLTAuNy0xOS44LTEuOSAxMy40IDQxLjcgNTIuMiA3Mi4xIDk4LjEgNzMtMzYgMjguMi04MS4yIDQ1LTEzMC41IDQ1LTguNSAwLTE2LjgtMC41LTI1LjEtMS41IDQ2LjYgMjkuOSAxMDEuOCA0Ny4yIDE2MS4xIDQ3LjIgMTkzLjIgMCAyOTguOS0xNjAuMSAyOTguOS0yOTguOSAwLTQuNi0wLjEtOS4xLTAuMy0xMy42IDIwLjUtMTQuNyAzOC4zLTMzLjIgNTIuNC01NC4zeiI+PC9wYXRoPgo8L3N2Zz4K"

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meta = __webpack_require__(32);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _contact = __webpack_require__(76);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _project = __webpack_require__(23);
	
	var _wrapper = __webpack_require__(9);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _projects = __webpack_require__(24);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _stylesModule = __webpack_require__(337);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Work = function Work(_ref) {
	  var location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_meta2.default, { title: 'Work', description: 'Web applications built built by or collaboratively with Shoaib Burq.', location: location }),
	    _projects2.default.map(function (project) {
	      return _react2.default.createElement(_project.ProjectPanel, { project: project, key: project.slug });
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.contact },
	      _react2.default.createElement(
	        _wrapper2.default,
	        null,
	        _react2.default.createElement(_contact2.default, { title: 'Your project here?' })
	      )
	    )
	  );
	};
	
	exports.default = Work;
	module.exports = exports['default'];

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contact":"src-pages-work----styles-module---contact---2Rfsk"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-index-jsx-90abe1a6ddaa989d2181.js